import { SUB_SESSION_QUERY_PARAM } from './wireContract';

export const isSameOriginUrl = (url: string): boolean => {
  try {
    return new URL(url, window.location.href).origin === window.location.origin;
  } catch {
    return false;
  }
};

const decodeQueryComponent = (component: string): string => {
  try {
    return decodeURIComponent(component.replace(/\+/g, ' '));
  } catch {
    return component;
  }
};

const isSubSessionPair = (pair: string): boolean =>
  decodeQueryComponent(pair.split('=')[0]) === SUB_SESSION_QUERY_PARAM;

export const readSubSessionIdFromSearch = (search: string): string | null =>
  new URLSearchParams(search).get(SUB_SESSION_QUERY_PARAM);

/**
 * Sets `ibe.ss` on the raw string: `URLSearchParams.toString()` would re-encode the other
 * parameters (e.g. `%20` to `+`) and could break signed meta links. Returns `search` itself when
 * it already carries the id exactly once, so URL sync does not fight other code that replaces
 * the URL.
 */
export const searchWithSubSessionId = (search: string, subSessionId: string): string => {
  const carriedIds = new URLSearchParams(search).getAll(SUB_SESSION_QUERY_PARAM);
  if (carriedIds.length === 1 && carriedIds[0] === subSessionId) {
    return search;
  }

  const pairs = search
    .replace(/^\?/, '')
    .split('&')
    .filter((pair) => pair !== '');
  const subSessionPair = `${SUB_SESSION_QUERY_PARAM}=${encodeURIComponent(subSessionId)}`;
  const existingIndex = pairs.findIndex(isSubSessionPair);

  const nextPairs =
    existingIndex === -1
      ? [...pairs, subSessionPair]
      : pairs
          .map((pair, index) => (index === existingIndex ? subSessionPair : pair))
          .filter((pair, index) => index === existingIndex || !isSubSessionPair(pair));

  return `?${nextPairs.join('&')}`;
};
